import { ButtonHTMLAttributes, FC } from 'react';

import { IconName } from '@purpur/library/icon';

import { RectangularButton } from './components/RectangularButton/RectangularButton';
import { GIFT_SELECTION_TEST_ID } from './constants';
import { useGiftPreviewModalControls } from './hooks/useGiftPreviewModalControls';

type Props = {
    uidForGiftPreviewModal: string;
    icon: IconName;
    children: string;
    isNegative: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const GiftPreviewButton: FC<Props> = ({ uidForGiftPreviewModal, children, icon, isNegative, ...inherited }) => {
    const { openGiftPreviewModal } = useGiftPreviewModalControls();

    return (
        <RectangularButton
            data-test={GIFT_SELECTION_TEST_ID.GIFT_PREVIEW_BUTTON}
            {...inherited}
            isNegative={isNegative}
            leftIcon={icon}
            rightIcon="chevron-right"
            onClick={(event) => openGiftPreviewModal(uidForGiftPreviewModal, event.currentTarget)}
        >
            {children}
        </RectangularButton>
    );
};
